import { trackAnalyticsEvent } from '@cof/refi-web-sdk';
import { environment } from '../../../environment/environment.js';

const ENV_PATH = environment.isStaticCloud() ? '/_origin/dxgw/_call' : '';

export const REFI_CREDITPULL_CONST = {
  GET_FEATURE_TOGGLE_URL: (featureKey) =>
    `${ENV_PATH}/protected/credit-pull/features/${featureKey}`,
  ICONIC_HARDPULL: 'iconic-hardpull',
  ICONIC_INVISIBLE_PQ: 'iconic-invisible-pq',
  COMBINED_HP_CONTRACT: 'combined-hp-cont',
  BASE_CREDIT_PULL_BFF_URL: `${ENV_PATH}/protected/credit-pull/applications/`,
  HTTP_HEADERS: {
    Accept: 'application/json;v=1',
    'Content-Type': 'application/json;v=1',
  },
  MAX_INCOME: 300000,
  REFI_SESSION_KEY: 'auto-refi-session',
  REFI_PI_KEY: 'auto-refi-pi',
  REFI_CI_KEY: 'refi-ci',
  MARKETING_ATTRIBUTE_COOKIE: 'afw3',
  LENDING_TREE_SRC_CD: 'SRLT03GENERICB***********',
  ROUTE_CHANGE: 'mfe-internal-route-change',
  ROUTE_CHANGE_EVENT: new CustomEvent('mfe-internal-route-change'),
  REVIEW_DISCONNECT_EVENT: new CustomEvent('review-disconnect'),
  STIPS_TASK_IDS: [4, 21, 38],
  VALID_ID_ANSWERS_EVENT: new CustomEvent('verified-id'),
  GO_TO_PREQUAL_EVENT: new CustomEvent('go-to-prequal'),
  TRACK_EVENT: trackAnalyticsEvent,
  TRACK_OFFER(offer) {
    document.dispatchEvent(
      new CustomEvent('refi-offer-card-shown', {
        bubbles: true,
        composed: true,
        detail: offer,
      })
    );
  },
  REFI_PROMO_STORAGE_KEY: 'auto-refi-offerkey',
  TIMEOUTS: {
    TWO_MINUTES: 120000,
    FIVE_SEC: 5000,
  },
  PATTERNS: {
    ALPHANUMERIC: /^[0-9a-zA-Z]+$/,
    NUMBER_ONLY: /^[0-9]+$/,
    DELETE_KEYS: /(Backspace)|(Delete)/,
  },
  MAX_REFI_AGE: 7,
  API_ERR_MSG:
    'Our system experienced an error. Please try again later. For help right now, you can call us at 1-888-263-4582.',
  EXISTING_HARDPULL_DECISION: 'Application has existing hardpull decision',
  API_DUPLICATE_HARDPULL_ERR_MSG:
    "This pre-qualification is no longer active. If you think you may have an active pre-qualification, please try closing your browser window and logging back in. If that doesn't work, please call us at 1-888-263-4582 Monday through Friday, from " +
    '9:00 a.m. to 7:00 p.m. Eastern Time.',
  REVIEW_SANDRA: {
    quote: `The process was easy and I was so happy with the result. I ended up saving money from the start.`,
    author: `Sandra H.`,
  },
  REVIEW_LISA: {
    quote: `This process was quick and seamless! I spoke to my rep on the phone and he walked me through finalizing my refinance.`,
    author: `Lisa W.`,
  },
  REVIEW_BRIAN: {
    quote: `I should have done this when you first offered it to me. The interest rate is lower than my previous rate. Dropped my car payment. The refinance was very easy.`,
    author: `Brian C.`,
  },
  // example of review with a comment
  // REVIEW_JOSEPH: {
  //   quote: `Filled out the application, submitted my current lender info, and Capital One took it from there! The loan was fulfilled in a matter of days.`,
  //   author: `Joseph, AR`,
  //   comment: `Once you eSign, we'll verify your information before paying off your lender.`,
  // },
  isSBEnv() {
    return window.location.hostname === 'auto-refi-sb.clouddqt.capitalone.com';
  },
  isDevEnv() {
    return window.location.hostname === 'auto-refi-dev.clouddqt.capitalone.com';
  },
  isQAEnv() {
    return (
      window.location.hostname === 'autorefi-ext-preprod.capitalone.com' ||
      window.location.hostname === 'auto-refi-qa.clouddqt.capitalone.com'
    );
  },
  isProdEnv() {
    return window.location.hostname === 'autorefi.capitalone.com';
  },
  IDP_REFRESH_URL:
    'https://apiit.capitalone.com/oauth2/authorize?client_id=97badff61fd8484aa9dd9e688cddab07&response_type=code&grant_type=authorization_code&scope=openid&prompt=none&redirect_uri=https://autorefi-ext-preprod.capitalone.com/auth',
  IDP_PROD_REFRESH_URL:
    'https://api.capitalone.com/oauth2/authorize?client_id=ce070671e75b45bdb6224ba33aeef398&response_type=code&grant_type=authorization_code&scope=openid&prompt=none&redirect_uri=https://autorefi.capitalone.com/auth',
  IDP_REFRESH_TIMEOUT_SECONDS: '840',
  UI_VARIANT: {
    compareToOldLoan: 'COMPARE_TO_OLD_LOAN',
  },
  TERM_VALUES: {
    extendTerm: 'Extend Loan Term',
    longestTerm: 'Longest Loan Term',
    sameTerm: 'Same Loan Term',
    shortenTerm: 'Shorten Loan Term',
    shortestTerm: 'Shortest Loan Term',
    adjustedTerm: 'Adjusted Loan Term',
  },
  GOAL_HEADER_TERM_VALUES: {
    extendTerm: 'More monthly savings with longer term',
    longestTerm: 'Most monthly savings with longest term',
    sameTerm: 'Save money without changing the term',
    shortenTerm: 'Pay off your loan faster',
    shortestTerm: 'Fastest way to pay off your loan',
    adjustedTerm: 'Adjusted Loan Term',
  },
  GOAL_HEADER_NON_SAVINGS_TERM_VALUES: {
    extendTerm: 'More time to pay off your loan',
    longestTerm: 'Most monthly savings with longest term',
    sameTerm: 'Keep your same loan term',
    shortenTerm: 'Pay off your loan faster',
    shortestTerm: 'Fastest way to pay off your loan',
    adjustedTerm: 'Adjusted Loan Term',
  },
  REFI_LOGO_URL: 'https://www.capitalone.com/auto-financing/refinance',
  COMPACT_COMPARE: 'compactcompare',
  NO_PAPERWORK_EXPERIENCE: 'nopaperwork',
  GOAL_HEADER_EXPERIENCE: 'goalheader',
  ADOBE_HOLDOUT_TAG: 'BAU_COMPARE_TO_OLD_LOAN',
  BANDIT_LOAD_EVENT: 'PageLoaded',
  BANDIT_DELIVERED_EVENT: 'Delivered',
  isAhead(loanStatus) {
    return loanStatus.toUpperCase().includes('AHEAD');
  },
  isBehind(loanStatus) {
    return loanStatus.toUpperCase().includes('BEHIND');
  },
  isControl(loanStatus) {
    return loanStatus.toUpperCase().includes('CONTROL');
  },
  isAPR(apr) {
    return apr != null;
  },
  RS_AHEAD_HEADER: "looks like you're ahead!",
  RS_BEHIND_HEADER: 'your offers are ready.',
  CREDITPULL_TYPE: {
    SOFTPULL: 'softpull',
    HARDPULL: 'hardpull',
  },
  EXP_FEEDBACK_EVENT: (experimentName, feedback) =>
    new CustomEvent('host-app-event', {
      bubbles: true,
      composed: true,
      detail: {
        actionName: 'experiment-feedback',
        data: {
          experimentName,
          feedback,
        },
      },
    }),
  EXP_INIT_EVENT: (experimentName) =>
    this.EXP_FEEDBACK_EVENT(experimentName, { feedbackEvent: 'Initialized' }),
  EXP_SUCCESS_EVENT: (experimentName, rewardValue = 1) =>
    this.EXP_FEEDBACK_EVENT(experimentName, {
      feedbackEvent: 'Success',
      rewardValue,
    }),
  HARDPULL_DECLINED: 'declined',
  HARDPULL_APPROVED: 'approved',
  HARDPULL_REVIEWING: 'reviewing',
  SHOW_TRANSITION_EVENT_NAME: 'internal-show-transition',
  SHOW_TRANSITION_EVENT: (shouldShow) =>
    new CustomEvent('internal-show-transition', {
      bubbles: true,
      composed: true,
      detail: {
        shouldShow,
      },
    }),
  TRANSITION_EVENT_NAME: 'internal-update-transition',
  TRANSITION_EVENT: (initiateAnimationCompletion, showCompletionAnimation) =>
    new CustomEvent('internal-update-transition', {
      bubbles: true,
      composed: true,
      detail: {
        initiateAnimationCompletion,
        showCompletionAnimation,
      },
    }),
};

export const REFI_PREQUAL_CONST = {
  SOFT_CREDIT_PULL_PATH: `~/credit-pull?type=SOFTPULL`,
  SOFT_CREDI_PULL_STATUS_PATH: `~/credit-pull/status?type=SOFTPULL&appReferenceId=`,
  BASE_EXPERIMENTATION_URL: `${ENV_PATH}/protected/40748/refi/prequalify/api/v1/experimentation/`,
  BASE_HOST_BFF_URL: `${ENV_PATH}/protected/831647/host-app/bff`,
  GET_APPLICATION_LIST_PATH: `/application-list`,
  ICONIC_STORAGE_KEY: 'iconic',
  ICONIC_INVISIBLE_PQ: 'iconic-invisible-prequal',
  REFI_PROMO_STORAGE_KEY: 'auto-refi-offerkey',
  REFI_PREQUAL_INFO_STORAGE_KEY: 'auto-refi-prequal',
  REFI_USED_MANUAL_LOAN_STORAGE_KEY: 'auto-refi-used-manual-loan',
  REFI_MANUEL_LOAN_STORAGE_KEY: 'auto-refi-manual-loan',
  REFI_SELECTED_LOAN_STORAGE_KEY: 'auto-refi-selected-loan',
  REFI_SELECTED_VEHICLE_STORAGE_KEY: 'auto-refi-selected-vehicle',
  REFI_UPFRONT_OFFERS_STORAGE_KEY: 'auto-refi-upfront-offers',
  SHOW_CREDIT_FREEZE_WARNING: 'showCreditFreezeWarning',
  MAX_OTP_PHONE_NUMBER_ATTEMPTS: 3,
  MAX_OTP_ATTEMPTS: 3,
  TIMEOUTS: {
    FIVE_SEC: 5000,
    TWO_MINS: 120000,
  },
  COOKIE_KEYS: {
    pfci: 'refi-ci',
  },
  PROMOTION_TYPES: {
    GUARANTEED_RATE: 'GUARANTEED_RATE',
    PRE_APPROVAL: 'PRE_APPROVAL',
  },
  C1_REFI_APPIDS: 'C1-REFI-APPIDS',
  STATES: {
    REVIEW: 'prequalify-review',
    PROCESSING: 'prequalify-processing',
    NO_OFFER: 'prequalify-no-offer',
    REVIEWING: 'prequalify-under-review',
    VERIFYING: 'prequalify-verifying',
    VERIFY_IDENTITY_ENTER_CODE: 'prequalify-identity-verification-enter-code',
    VERIFY_IDENTITY_SUCCESS: 'prequalify-identity-verification-success',
    VERIFY_IDENTITY_FAILED: 'prequalify-identity-verification-failed',
    PROCESSING_PRE_APPROVAL: 'prequalify-processing-pre-approval',
  },
  STATUSES: {
    REVIEW: 'softpull/review',
    PROCESSING: 'softpull/processing',
    NO_OFFER: 'softpull/no-offer',
    REVIEWING: 'softpull/reviewing',
    VERIFYING: 'softpull/verifying',
    VERIFY_IDENTITY_ENTER_CODE: 'softpull/verify-identity/enter-code',
    VERIFY_IDENTITY_SUCCESS: 'softpull/verify-identity/success',
    VERIFY_IDENTITY_FAILED: 'softpull/verify-identity/failed',
    PROCESSING_PRE_APPROVAL: 'softpull/processing-pre-approval',
    OFFER: 'offer',
  },
  V2_STATUSES: {
    REVIEW: 'review',
    PROCESSING: 'processing',
    NO_OFFER: 'no-offer',
    REVIEWING: 'reviewing',
    VERIFYING: 'verifying',
    VERIFY_IDENTITY_SEND_CODE: 'verify-identity/send-code',
    VERIFY_IDENTITY_ENTER_CODE: 'verify-identity/enter-code',
    VERIFY_IDENTITY_SUCCESS: 'verify-identity/success',
    VERIFY_IDENTITY_FAILED: 'verify-identity/failed',
    PROCESSING_PRE_APPROVAL: 'processing-pre-approval',
    OFFER: 'offer',
  },
  MARKETING_SOURCES: {
    OFFER: 'offer',
  },
  ACTIVE_INCOME_VERIFICATION_TYPE: {
    yes: 'Yes',
    no: 'No',
  },
  PROGRESS_BAR_MICRO_STEPS: {
    macroStepName: 'Check eligibility',
    microStepsList: [
      'name',
      'communication',
      'identity',
      'address',
      'employment',
      'income',
      'coborrower',
      'co-app-communication',
      'co-app-identity',
      'co-app-address',
      'co-app-employment',
      'co-app-income',
      'termsAndConditions',
      'vehicleLoan',
      'vehicle',
      'loan',
      'review',
    ],
  },
};

export const REFI_APP_STATUSES = {
  NO_DECISION: 400,
  DECLINED: 402,
  REVIEWING: 403,
  VERIFYING: 404,
  APPROVED: 405,
};

export const REFI_PAGES = {
  CXT_COMBINED_HARDPULL: 'hardpull/cxt-combined-hardpull',
  DELAYED_HARDPULL_PRIMER: 'hardpull/delayed-hardpull-primer',
  COMBINED_HP_CONTRACT: 'hardpull/combined-hardpull-contract',
  DELAYED_HARDPULL_CONSENT: 'hardpull/delayed-hardpull-consent',
  CREDIT_CONSENT: 'hardpull/credit-consent',
  HARDPULL_REVIEWING: 'hardpull/reviewing',
  HARDPULL_PROCESSING: 'hardpull/processing',
  HARDPULL_DECLINED: 'hardpull/decline',
};

export const REFI_STATES = {
  CXT_COMBINED_HARDPULL: 'cxt-combined-hardpull',
  COMBINED_HP_CONTRACT: 'combined-hp-cont',
  DELAYED_HARDPULL_PRIMER: 'delayed-hardpull-primer',
  DELAYED_HARDPULL_CONSENT: 'delayed-hardpull-consent',
  CREDIT_CONSENT: 'credit-consent',
  HARDPULL_REVIEWING: 'reviewing',
  HARDPULL_PROCESSING: 'processing',
  HARDPULL_DECLINED: 'declined',
};
